import React, { FunctionComponent } from 'react'
import { Link, Element } from 'react-scroll'
import useStyles from './style'
import { Typography, Paper } from '@material-ui/core'

const ContentTable: FunctionComponent<{ to: string }> = ({ to, children }) => {
  const classes = useStyles()
  return (
    <>
      <Element name={to} />
      <Typography className={classes.title} component={Paper} elevation={12}>
        <Link
          to={to}
          activeClass="active"
          spy={true}
          smooth={true}
          offset={-70}
        >
          {children}
        </Link>
      </Typography>
    </>
  )
}

export default ContentTable
